import { render, staticRenderFns } from "./ListMarketplace.vue?vue&type=template&id=05f21d2a&"
import script from "./ListMarketplace.vue?vue&type=script&lang=js&"
export * from "./ListMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports